module.exports = __webpack_public_path__ + "resource/img/question_form.3ffa1f42.svg";